import { AppTypes, SdkElement, SdkFC } from "@mychoice/mychoice-sdk-components";
import { AppWrapper } from "@mychoice/mychoice-sdk-modules";
import "@mychoice/mychoice-sdk-styles";

const App: SdkFC = (): SdkElement => (
  <AppWrapper appType={AppTypes.BeginInsurance} />
);

export default App;
